import { usePage } from "@inertiajs/react";

export type FeatureName = string;

export default function useFeature(name: FeatureName): boolean {
  const { features } = usePage().props as {
    features?: Record<string, boolean>;
  };
  return features?.[name] ?? false;
}
